import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBa3G2R9Tp2XmPWbE0e-cnupIrWu4qXC8o",
  authDomain: "portfolio-ae14c.firebaseapp.com",
  projectId: "portfolio-ae14c",
  storageBucket: "portfolio-ae14c.appspot.com",
  messagingSenderId: "413644011833",
  appId: "1:413644011833:web:f976067bb3a23446c510e8",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
